import Image from 'next/image';
import React from 'react';
import Logo from '@/public/logo.svg';
import Container from '../ui/container';
const NotFound = ({ title }: { title: string }) => {
  return (
    <Container>
      <div className="relative mx-auto grid h-full w-[90%] place-items-center py-14">
        <Image
          src={Logo}
          fill
          alt="logo"
          className="pointer-events-none object-contain opacity-10"
          priority
        />
        <h2 className="text-primary/30 text-center text-[clamp(2rem,1.07rem_+_3.7vw,4rem)] font-bold capitalize">
          {title}
        </h2>
      </div>
    </Container>
  );
};

export default NotFound;
